import BaseAPIService from '../base/base-api-service';
import ProductModel from 'src/model/product.model';

class BrowsingHistoryService extends BaseAPIService<ProductModel> {
  public endpoint: string = '/navapp/v1/browsingHistory';

  constructor() {
    super(ProductModel);
  }

  public getProducts(size: number = 10): Promise<ProductModel[]> {
    return this.getByParams(this.endpoint, { size });
  }
}

const BrowsingHistoryServiceInstance = new BrowsingHistoryService();
Object.freeze(BrowsingHistoryServiceInstance);

export default BrowsingHistoryServiceInstance;
